import React from 'react';
import Menu from "../Modules/Menu";

export default function TopArea() {
    const [topMenuOpened, setTopMenuOpened] = React.useState(false);
    return (
        <header className={topMenuOpened ? 'topArea menuOpened ' : 'topArea'}>
            <img className="logo" src="/Images/Site/Logo.png" alt="Barpazir" title="Barpazir" />
            <Menu onToggled={(menuState) => setTopMenuOpened(menuState)} />
        </header>
    );
}
